export const MFA_SELECT = 'app/MFA/SELECT_FACTOR';
export const MFA_SAVE_SELECTED_FACTOR= 'MFA_SAVE_SELECTED_FACTOR';


